import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <h1>プライバシーポリシー</h1>
        <p className="legal-page__updated">最終更新日: 2025年6月30日</p>

        <section>
          <h2>1. はじめに</h2>
          <p>本プライバシーポリシーは、当社が収集する個人情報の種類、その使用方法、および保護方法について説明するものです。当社は、ユーザーのプライバシーを尊重し、個人情報の保護に努めています。</p>
        </section>

        <section>
          <h2>2. 収集する情報</h2>
          <p>当社は、以下の情報を収集することがあります：</p>
          <ul>
            <li><strong>アカウント情報：</strong> 登録時に提供される名前、電話番号、メールアドレス、パスワード、生年月日、性別など</li>
            <li><strong>プロフィール情報：</strong> プロフィール写真、自己紹介文など、ユーザーが公開することを選択した情報</li>
            <li><strong>コンテンツ：</strong> ユーザーが投稿、アップロード、共有する写真、コメント、メッセージなど</li>
            <li><strong>使用データ：</strong> IPアドレス、デバイス情報、位置情報、閲覧履歴、クッキーデータなど</li>
          </ul>
        </section>

        <section>
          <h2>3. 情報の使用方法</h2>
          <p>当社は、収集した情報を以下の目的で使用します：</p>
          <ul>
            <li>本サービスの提供、維持、改善</li>
            <li>ユーザーアカウントの作成と管理</li>
            <li>ユーザーの認証とセキュリティ確保</li>
            <li>カスタマイズされたコンテンツの提供</li>
            <li>コミュニケーション（通知、更新情報、マーケティングメッセージなど）</li>
            <li>広告の表示とその効果測定</li>
            <li>不正行為の検出と防止</li>
          </ul>
        </section>

        <section>
          <h2>4. 情報の共有</h2>
          <p>当社は、以下の場合を除き、ユーザーの個人情報を第三者と共有しません：</p>
          <ul>
            <li>ユーザーの同意がある場合</li>
            <li>サービス提供のために必要な場合（サービスプロバイダー、パートナー企業など）</li>
            <li>法的要請に応じる必要がある場合</li>
            <li>当社の権利、財産、安全を保護する必要がある場合</li>
          </ul>
        </section>

        <section>
          <h2>5. Cookieの使用</h2>
          <p>当社は、ユーザー体験の向上や分析のためにCookieを使用しています。Cookieの詳細については、<Link to="/cookies">Cookieポリシー</Link>をご覧ください。</p>
        </section>

        <section>
          <h2>6. データ保持</h2>
          <p>当社は、サービス提供に必要な期間、またはその他の法的義務を果たすために必要な期間、ユーザー情報を保持します。ユーザーがアカウントを削除した場合、一部のデータは法的または業務上の目的で一定期間保持される場合があります。</p>
        </section>

        <section>
          <h2>7. セキュリティ</h2>
          <p>当社は、ユーザーの個人情報を保護するために適切な技術的・組織的措置を講じています。ただし、インターネット上の転送や電子的保存の方法は100％安全ではないことをご理解ください。</p>
        </section>

        <section>
          <h2>8. ユーザーの権利</h2>
          <p>ユーザーには以下の権利があります：</p>
          <ul>
            <li>個人情報へのアクセスと修正</li>
            <li>個人情報の削除（「忘れられる権利」）</li>
            <li>データポータビリティ（データの移転）</li>
            <li>処理の制限やオプトアウト</li>
          </ul>
          <p>これらの権利を行使するには、当社の連絡先までご連絡ください。</p>
        </section>

        <section>
          <h2>9. 子供のプライバシー</h2>
          <p>本サービスは18歳未満の子供を対象としていません。18歳未満の子供から個人情報を収集していると判明した場合、当社はその情報を直ちに削除します。</p>
        </section>

        <section>
          <h2>10. ポリシーの変更</h2>
          <p>当社は、必要に応じて本プライバシーポリシーを変更することがあります。変更があった場合は、本サービス上で通知します。</p>
        </section>

        <section>
          <h2>11. 連絡先</h2>
          <p>本プライバシーポリシーに関するご質問やお問い合わせは、<a href="mailto:support@deli-ns.com">support@deli-ns.com</a>までご連絡ください。</p>
        </section>

        <div className="legal-page__footer">
          <Link to="/" className="legal-page__back">ホームに戻る</Link>
        </div>
      </div>
    </div>
  );
}

export default Privacy; 